// extracted by mini-css-extract-plugin
module.exports = {"layout":"DevLayout_layout__22vs4","announcements":"DevLayout_announcements__1MhgL","layoutContent":"DevLayout_layoutContent__GTnUl"};